import LogoTree from "../assets/images/logos/tree_logo_white.png";
import LogoOnzeEnergie from "../assets/images/logos/onze_energie.svg";
import LogoNotreEnergie from "../assets/images/logos/notre_energie.svg";
import LogoJosworld from "../assets/images/logos/josworld.svg";
import translate from "../locales";
import { useContext } from "react";
import { LanguageContext } from "../app";
import { CarouselComponent } from "@tree-company/test-it-components";
import coops from "../data/coops.json";
import { Languages } from "@tree-company/collect-js-client";

CarouselComponent.register();

export function Footer() {
  const language = useContext(LanguageContext);

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__top-left">
          <a
            href="#"
            className="footer__link footer__link--logo"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={
                language == Languages.nl ? LogoOnzeEnergie : LogoNotreEnergie
              }
              alt="Onze Energie"
              className="footer__logo footer__logo--main"
            />
          </a>
        </div>
        <div className="footer__top-right">
          <div className="footer__logos">
            <span className="footer__made-by">
              {translate("footer.made_by", {}, language)}
            </span>

            <a
              href="https://www.josworld.org"
              className="footer__link footer__link--logo"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={LogoJosworld} alt="Josworld" className="footer__logo" />
            </a>
            <a
              href="https://treecompany.be"
              className="footer__link footer__link--logo"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={LogoTree} alt="Tree company" className="footer__logo" />
            </a>
          </div>

          <a
            className="footer__privacy"
            href={translate("footer.privacy_url", {}, language)}
          >
            {translate("footer.privacy_text", {}, language)}
          </a>
        </div>
      </div>
      <hr className="footer__hr"></hr>
      <div className="footer__bottom">
        <span className="footer__partners-text">
          {translate("footer.initiative", {}, language)}
        </span>
        <div className="footer__partner-logos">
          <tree-carousel class="carousel">
            <div className="carousel__viewport">
              <div className="carousel__scroller" data-carousel="scroller">
                {coops[
                  (language === "nl" ? "nl" : "fr") as keyof typeof coops
                ].map((coop: { file: string; name: string }) => (
                  <div
                    className="carousel__item"
                    data-carousel="item"
                    key={coop.file}
                  >
                    <img
                      src={coop.file}
                      alt={coop.name}
                      className="partner-logo"
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="carousel__actions">
              <button
                className="carousel__button carousel__button--previous carousel-button"
                data-carousel="previous"
              >
                <svg
                  className="carousel-button__icon"
                  viewBox="0 0 8 13"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.148148 6.03833L6.17057 0.03833L7.57581 1.43833L2.95861 6.03833L7.57581 10.6383L6.17057 12.0383L0.148148 6.03833Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
              <button
                className="carousel__button carousel__button--next carousel-button"
                data-carousel="next"
              >
                <svg
                  className="carousel-button__icon"
                  viewBox="0 0 8 13"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.83049 6.03833L1.80806 12.0383L0.402832 10.6383L5.02002 6.03833L0.402832 1.43833L1.80806 0.03833L7.83049 6.03833Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>
          </tree-carousel>
        </div>
      </div>
    </footer>
  );
}
